<template>
  <div class="profile-card">
    <div class="avatar">
      <img :src="avatarUrl" alt="Avatar" />
    </div>
    <div class="info">
      <h2>{{ displayName }}</h2>
      <p class="muted">ایمیل: {{ email }}</p>
      <p class="muted">نقش: {{ role }}</p>
    </div>
  </div>
  <AIProviders v-if="role === 'admin'" />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
const AIProviders = defineAsyncComponent(() => import('../components/AIProviders.vue'))
import { useQuery } from '@vue/apollo-composable'
import { USER_INFO_QUERY } from '../api/queries'

const { result } = useQuery(USER_INFO_QUERY)
const email = computed(() => result.value?.userInfo?.user?.email || '')
const role = computed(() => result.value?.userInfo?.user?.role || 'user')
const displayName = computed(() => (email.value ? email.value.split('@')[0] : 'کاربر'))
const avatarUrl = computed(() => `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(email.value || displayName.value)}`)
</script>

<script>
export default { name: 'SettingsView' }
</script>

<style scoped>
.profile-card { display:flex; align-items:center; gap:20px; background: var(--card); border:1px solid var(--border); border-radius:16px; padding:24px; box-shadow: 0 8px 24px rgba(0,0,0,0.06); }
.avatar img { width:80px; height:80px; border-radius:50%; border:1px solid var(--border); }
.muted { color: var(--muted); }
</style>
